import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import ClassificationMeter from '@components/charts/classificationMeter/index'

import { StatusContainer, ClassificationContainer } from './styles'

const equipmentStatus = ({
  equipmentData, status, onChange, loading, beneficiaryWithCollectionCount
}) => {

  const {
    activeLoans, diabeticsWithGlucometer, equipmentInUse
  } = equipmentData || 0

  return (
    <StatusContainer>
      <ClassificationContainer>
        <ClassificationMeter
          loading={loading}
          type="activeLoans"
          status={status}
          onSelect={onChange}
          value={activeLoans}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="diabeticsWithGlucometer"
          status={status}
          onSelect={onChange}
          value={diabeticsWithGlucometer}
          maxValue={beneficiaryWithCollectionCount}
        />
        <ClassificationMeter
          loading={loading}
          type="equipmentInUse"
          status={status}
          onSelect={onChange}
          value={equipmentInUse}
          maxValue={beneficiaryWithCollectionCount}
        />
      </ClassificationContainer>

    </StatusContainer>
  )
}

equipmentStatus.propTypes = {
  loading: PropTypes.bool,
  equipmentData: PropTypes.shape({
    activeLoans: PropTypes.number,
    diabeticsWithGlucometer: PropTypes.number,
    equipmentInUse: PropTypes.number,
  }),
  status: PropTypes.shape({
    activeLoans: PropTypes.bool,
    diabeticsWithGlucometer: PropTypes.bool,
    equipmentInUse: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  beneficiaryWithCollectionCount: PropTypes.number,
}

equipmentStatus.defaultProps = {
  equipmentData: null,
  loading: false,
  beneficiaryWithCollectionCount: 0,
}

const mapStateToProps = ({ overview, beneficiary }) => ({
  equipmentData: overview.equipmentData,
  beneficiaryWithCollectionCount: beneficiary.beneficiaryWithCollectionCount,
})

export default connect(mapStateToProps, null)(equipmentStatus)
